import { render, staticRenderFns } from "./user-feedback.vue?vue&type=template&id=7dfe43c4"
import script from "./user-feedback.vue?vue&type=script&lang=js"
export * from "./user-feedback.vue?vue&type=script&lang=js"
import style0 from "./user-feedback.vue?vue&type=style&index=0&id=7dfe43c4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports